
























































import RequestQuote from '@/graphql/mutations/requestQuote.gql';
import ClinicWithProcedures from '@/graphql/queries/clinicWithProcedures.gql';
import request from '@/graphql/request';
import Vue from 'vue';
import { Carousel, Slide } from 'vue-carousel';
import Component from 'vue-class-component';

interface IProcedureBasic {
  id: string;
  name: string;
  description: string;
}

@Component({
  components: {
    Carousel,
    Slide,
  },
})
export default class Clinic extends Vue {
  public id: string = '';
  public search: string = '';
  public procedures: IProcedureBasic[] = [];
  public filteredProcedures: IProcedureBasic[] = [];
  public clinic?: {
    name: string;
    description: string;
    images: Array<{ url: string }>;
    location: any;
  } = {
    name: '',
    description: '',
    images: [],
    location: {
      id: '',
      name: '',
      city: '',
    },
  };

  public mounted() {
    this.id = this.$route.query.id;

    request(ClinicWithProcedures, { id: this.id })
      .then(response => {
        if (!response || !response.data) {
          console.error('No procedures returned');
          return;
        }

        this.clinic = response.data.clinic;
        this.procedures = response.data.clinic.procedures.map((p: any) => ({
          ...p.procedure,
          price: p.price,
        }));
        this.filteredProcedures = [...this.procedures];
      })
      .catch(console.error);
  }

  public onChange() {
    if (!this.search) {
      this.filteredProcedures = [...this.procedures];
    } else {
      this.filteredProcedures = this.procedures.filter(
        proc =>
          proc.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          proc.description.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      );
    }
  }

  public formatPrice(price: number) {
    return (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  public addToCart(procedureId: string) {
    this.$store.dispatch('cart/changeClinic', this.id);
    this.$store.dispatch('cart/addProcedure', procedureId);
  }
}
